import styled from 'styled-components'
import { CSS } from 'ui/helpers'

export const Label = styled.label<{ $error?: boolean }>`
  color: ${(p) => (p.$error ? p.theme.uiKit.colors.theme.negative.darker : p.theme.uiKit.colors.global.grey.grey700)};
  display: block;
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyM.semiBold)};
  margin-bottom: 4px;
`
